<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-chronology.svg" can-back-flag="1"></Header>
    </header>

    <!--画像-->
    <div id="wrapper">
      <div class="content">
        <div class="chronology-list-box2">
          <ul>
            <li v-for='row in rows' v-bind:key='row.id'>
              <dl>
    						<dt v-show="row.logo != ''"><img :src="row.logo" alt="戦後史"></dt>
                <dd>
                  <a :href="row.link" target="_blank" rel="noopener">
                    <div class="pageno">{{row.page}}</div>
                    <div class="text">{{row.title}}</div>
                  </a>
                </dd>
              </dl>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--
    <p>
      <img :src="content" width="100%"/>
    </p>
    -->

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  mounted: function () {
    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-chronology")
    $("body").addClass("page-chronology-index")
    cmd.adjustStyle()

    this.search()
  },
  methods: {
    ...mapActions('TimelineModule', {
      'prevAction': 'prevAction',
      'search': 'search',
    }),

  },
  computed: {    
    ...mapGetters('TimelineModule', {
      'content': 'content',
      'rows': 'getRows',
    })
  },
  components: {
    Header
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Timeline.vue